import type { ScopedProject } from "@domain/project/project-guards";

export enum ProjectEventType {
  PROJECT_OPENED = "PROJECT_OPENED",
  PROJECT_CLOSED = "PROJECT_CLOSED",
  FLOORPLAN_ADDED = "FLOORPLAN_ADDED",
  FLOORPLAN_UPDATED = "FLOORPLAN_UPDATED",
  FLOORPLAN_DELETED = "FLOORPLAN_DELETED",
  IMAGE_ADDED = "IMAGE_ADDED",
  IMAGE_UPDATED = "IMAGE_UPDATED",
  IMAGE_DELETED = "IMAGE_DELETED",
  ALARM_DEVICE_CONFIGURATION_ADDED = "ALARM_DEVICE_CONFIGURATION_ADDED",
  TRANSMITTER_CONFIGURATION_ADDED = "TRANSMITTER_CONFIGURATION_ADDED",
  FLAME_DETECTOR_CONFIGURATION_ADDED = "FLAME_DETECTOR_CONFIGURATION_ADDED",
  GAS_WARNING_CENTER_CONFIGURATION_ADDED = "GAS_WARNING_CENTER_CONFIGURATION_ADDED",
  SIGNAL_ELEMENT_CONFIGURATION_ADDED = "SIGNAL_ELEMENT_CONFIGURATION_ADDED",
  PLASTIC_SIGN_CONFIGURATION_ADDED = "PLASTIC_SIGN_CONFIGURATION_ADDED",
  PATIENT_MONITOR_CONFIGURATION_ADDED = "PATIENT_MONITOR_CONFIGURATION_ADDED",
  CENTRAL_STATION_CONFIGURATION_ADDED = "CENTRAL_STATION_CONFIGURATION_ADDED",
  TELEMETRY_CONFIGURATION_ADDED = "TELEMETRY_CONFIGURATION_ADDED",
  KVM_CONFIGURATION_ADDED = "KVM_CONFIGURATION_ADDED",
  DISPLAY_CONFIGURATION_ADDED = "DISPLAY_CONFIGURATION_ADDED",
  UTILITY_CONFIGURATION_ADDED = "UTILITY_CONFIGURATION_ADDED",
  ALARM_DEVICE_CONFIGURATION_UPDATED = "ALARM_DEVICE_CONFIGURATION_UPDATED",
  TRANSMITTER_CONFIGURATION_UPDATED = "TRANSMITTER_CONFIGURATION_UPDATED",
  FLAME_DETECTOR_CONFIGURATION_UPDATED = "FLAME_DETECTOR_CONFIGURATION_UPDATED",
  GAS_WARNING_CENTER_CONFIGURATION_UPDATED = "GAS_WARNING_CENTER_CONFIGURATION_UPDATED",
  SIGNAL_ELEMENT_CONFIGURATION_UPDATED = "SIGNAL_ELEMENT_CONFIGURATION_UPDATED",
  PLASTIC_SIGN_CONFIGURATION_UPDATED = "PLASTIC_SIGN_CONFIGURATION_UPDATED",
  PATIENT_MONITOR_CONFIGURATION_UPDATED = "PATIENT_MONITOR_CONFIGURATION_UPDATED",
  CENTRAL_STATION_CONFIGURATION_UPDATED = "CENTRAL_STATION_CONFIGURATION_UPDATED",
  TELEMETRY_CONFIGURATION_UPDATED = "TELEMETRY_CONFIGURATION_UPDATED",
  KVM_CONFIGURATION_UPDATED = "KVM_CONFIGURATION_UPDATED",
  DISPLAY_CONFIGURATION_UPDATED = "DISPLAY_CONFIGURATION_UPDATED",
  PRODUCT_CONFIGURATION_PRODUCT_LIST_QUANTITY_UPDATED = "PRODUCT_CONFIGURATION_PRODUCT_LIST_QUANTITY_UPDATED",
  DIRECT_BOM_ENTRY_ADDED = "DIRECT_BOM_ENTRY_ADDED",
  DIRECT_BOM_ENTRY_UPDATED = "DIRECT_BOM_ENTRY_UPDATED",
  UTILITY_CONFIGURATION_UPDATED = "UTILITY_CONFIGURATION_UPDATED",
  ALARM_DEVICE_CONFIGURATION_DELETED = "ALARM_DEVICE_CONFIGURATION_DELETED",
  TRANSMITTER_CONFIGURATION_DELETED = "TRANSMITTER_CONFIGURATION_DELETED",
  FLAME_DETECTOR_CONFIGURATION_DELETED = "FLAME_DETECTOR_CONFIGURATION_DELETED",
  GAS_WARNING_CENTER_CONFIGURATION_DELETED = "GAS_WARNING_CENTER_CONFIGURATION_DELETED",
  SIGNAL_ELEMENT_CONFIGURATION_DELETED = "SIGNAL_ELEMENT_CONFIGURATION_DELETED",
  PLASTIC_SIGN_CONFIGURATION_DELETED = "PLASTIC_SIGN_CONFIGURATION_DELETED",
  PATIENT_MONITOR_CONFIGURATION_DELETED = "PATIENT_MONITOR_CONFIGURATION_DELETED",
  CENTRAL_STATION_CONFIGURATION_DELETED = "CENTRAL_STATION_CONFIGURATION_DELETED",
  TELEMETRY_CONFIGURATION_DELETED = "TELEMETRY_CONFIGURATION_DELETED",
  KVM_CONFIGURATION_DELETED = "KVM_CONFIGURATION_DELETED",
  DISPLAY_CONFIGURATION_DELETED = "DISPLAY_CONFIGURATION_DELETED",
  UTILITY_CONFIGURATION_DELETED = "UTILITY_CONFIGURATION_DELETED",
  SYNCED_TO_CLOUD = "SYNCED_TO_CLOUD",
  PLACEHOLDER_PRODUCTS_UPDATED = "PLACEHOLDER_PRODUCTS_UPDATED",
  PRODUCT_LIST_DISCOUNT_UPDATED = "PRODUCT_LIST_DISCOUNT_UPDATED",
}

export interface ProjectEvent {
  project: ScopedProject;
  type: ProjectEventType;
  subject: any;
}
